<template>
    <header>
		


    </header>

</template>

<script>

  export default {
	name: 'Header'
  }

</script>


<style lang="scss" scoped>
	@import '../scss/style.scss';
</style>
